<template>
  <div class="px-4 py-2 flex justify-between items-center bg-gray-50">
    <div class="text-sm text-gray-800">{{meta.total}} Ergebnisse</div>
    <div class="flex">
      <basic-button
        :disabled="!hasPreviousPage"
        color="white"
        class="mr-2"
        size="sm"
        @click="previous"
      >Zurück</basic-button>
      <basic-button :disabled="!hasNextPage" color="white" size="sm" @click="next">Weiter</basic-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    meta: Object
  },

  computed: {
    hasNextPage() {
      return this.meta.current_page < this.meta.last_page;
    },
    hasPreviousPage() {
      return this.meta.current_page > 1;
    }
  },

  methods: {
    next() {
      this.$emit("next");
    },
    previous() {
      this.$emit("previous");
    }
  }
};
</script>